export const UPDATED_UNIT = "updated_unit";
export const WEATHER_DATA_LOADED = "weather_data_loaded";
